module.exports = __webpack_public_path__ + "img/saishianpai-icon-2.25c93946.png";